import { AutocompleteInput, AutocompleteInputProps } from "react-admin";
import React from "react";

interface Props extends AutocompleteInputProps {
  choicesFilter?: (choices?: object[], optionValue?: string) => object[];
}

export const ProLogsAutocompleteInput = ({
  choicesFilter,
  ...props
}: Props) => {
  if (choicesFilter) {
    props = {
      ...props,
      choices: choicesFilter(props.choices, props.optionValue),
    };
  }

  return <AutocompleteInput {...props} />;
};
